<template>
    <div class="modal-card card">
        <form>
            <div class="card-header">
                <!-- Title -->
                <h4 class="card-header-title">
                    Add aUT Credential
                </h4>
                <!-- Close -->
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="card-body">
                <input-field label="URL" type="text" v-model="url" placeholder="Enter URL" :toolTip="'Credential URL for IP hashing'" />
            </div>
            <div class="card-footer">
                <div class="d-flex justify-content-between align-items-center">
                    <div>
                        <div class="text-danger">
                            {{ error }}
                        </div>
                    </div>
                    <button type="button" class="btn btn-primary" @click="handleSubmit" :disabled="loading || !url">
                        <div v-if="loading" class="spinner-border spinner-border-sm" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                        <div v-else>
                            Submit
                        </div>
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import InputField from '../InputField.vue'
import { mapActions } from 'vuex'
export default {
    components: { InputField },
    props: {
        modalData: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            loading: false,
            error: "",
            url: "",
        }
    },
    name: "AddAutCredential",
    methods: {
        ...mapActions('aut', {
            createCredential: 'createAutCredential'
        }),
        async handleSubmit() {
            this.error = "";
            this.loading = true;
            try {
                await this.createCredential({ url: this.url })
                let toastOptions = {
                    message: "Credential added successfully",
                    type: "success"
                }
                this.$store.dispatch("addToast", toastOptions);
                this.$store.dispatch('hideModal');
                if (this.modalData?.refreshCredentials) {
                    this.modalData.refreshCredentials();
                }
            } catch (error) {
                this.error = error.response?.data.error ? error.response.data.error : error.message;
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>

<style></style>